import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import State from './state';

export default {
  state: new State(),
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./static-content/private/javascripts/store/modules/states/states.ts